module.exports = __webpack_public_path__ + "img/austria.8f8286e1.svg";